module.exports = __webpack_public_path__ + "img/9788971967867.f7543e56.jpg";